import USER_LEAD_STATUSES from 'constants/userLeadStatuses';
import { isFeatureEnabled, publicEnvConfig } from 'helpers/env';
import { getScreen } from 'helpers/window';
import { loggedUSerSelector } from 'store/slices/loggedUsers/selector';
import { getState } from 'store/store';
import { notifyError } from '../../errorNotifier';
import BuyerEvents from './eventsDictionary/buyers';
import { getGoogleAnalyticsClientIdFromCookie, getGoogleClickIdFromCookie } from '../GoogleAnalytics';

const getCurrentDealershipTrackingProperties = () => {
	const loggedUser = loggedUSerSelector(getState());
	if (!loggedUser?.id) return {};

	const properties = {
		current_dealership_region_name: loggedUser.current_dealership_region_name,
		current_dealership_territory_name: loggedUser.current_dealership_territory_name,
		current_dealership_territory_model: loggedUser.current_dealership_territory_model,
	};

	return Object.fromEntries(
		Object.entries(properties).filter(([, value]) => typeof value === 'string' && value.trim()),
	);
};

const getSegmentScreenObject = (params) => {
	const screen = getScreen();
	const googleAnalyticsClientId = getGoogleAnalyticsClientIdFromCookie();
	const googleClickId = getGoogleClickIdFromCookie();

	let segmentObject = screen ? { ...params, screen } : { ...params };

	if (googleAnalyticsClientId) {
		segmentObject.google_analytics_client_id = googleAnalyticsClientId;
	}

	if (googleClickId) {
		segmentObject.gclid = googleClickId;
	}

	return { ...segmentObject, ...getCurrentDealershipTrackingProperties() };
};

export const segmentTrack = (action, params, user) => {
	if (!isFeatureEnabled(publicEnvConfig.SEGMENT_ENABLED)) return;

	try {
		const newParams = { ...params };

		// Check if the user is in preview mode and update the lead_status accordingly
		if (user?.lead_status === USER_LEAD_STATUSES.preview_mode) {
			newParams.lead_status = user.lead_status;
		}

		if (window.analytics) {
			window.analytics.track(action, getSegmentScreenObject(newParams));
		}
	} catch (error) {
		notifyError(error);
	}
};

export const parsePageData = ({ asPath, name, subCategory }) => {
	const path = asPath.split('?')[0];
	const segmentName = `${subCategory}|${name}`;
	return { path, segmentName };
};

export const segmentPageView = (name, properties) => {
	if (!isFeatureEnabled(publicEnvConfig.SEGMENT_ENABLED)) return;

	const category = 'backlotcarscom';
	const title = `${category}|${name}`;

	try {
		if (window.analytics) {
			window.analytics.page(
				category,
				title,
				getSegmentScreenObject({
					...properties,
					title,
				}),
			);
		}
	} catch (error) {
		notifyError(error);
	}
};

export const events = {
	...BuyerEvents,
};
